
<!-- <div class="custombg fixed-top">
    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div> -->
  <div class="wrapper">
    <div class="skill-repo py-3">
      <div class="skill-competency-tile skill-repo-cards pointer-cursor"
        *ngFor="let comp of dataWithCount"
        (click)="opensubcompetencypage(comp, $event)">
        <div class="comp-header-image"
          [ngStyle]="{background:'url(' + getImageSrc(comp.titlesubcomp) + ') no-repeat 0 0 / cover'}">
          <h1 class="comp-main-count h1 fw-400 mb-0">
            <span>{{ comp.count }}</span>
          </h1>
          <h4 class="comp-main-header h3 mb-0">{{ comp.titlesubcomp }}</h4>
        </div>
      </div>
    </div>
  </div>